import { Text, View } from '@react-pdf/renderer'
import { DateTime } from 'luxon'

import { millisecondsToHumanReadableString } from '@/utils/time'
import COLORS from '@/constants/colors'
import type { VolunteerActivityAttributes } from '@/server/models'

import { PORTFOLIO_STYLES } from '@/components/Transcript/styles'

export function Activities({
  activities,
  startDateString,
  endDateString,
  totalTime,
}: {
  activities: Omit<VolunteerActivityAttributes, 'reviewer_id' | 'deleted_at' | 'session_id'>[]
  startDateString: string
  endDateString: string
  totalTime: string
}): React.ReactElement {
  return (
    <View>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '16px',
        }}
      >
        <View>
          <Text
            style={{
              fontFamily: 'greycliffcf',
              fontSize: '14px',
              lineHeight: 1.3,
            }}
          >
            Volunteer Hours Details
          </Text>
        </View>
        <View>
          <Text
            style={{
              fontFamily: 'proximanova',
              fontSize: '10px',
              lineHeight: 1.3,
            }}
          >
            Dates: {startDateString} - {endDateString}
          </Text>
        </View>
      </View>
      <View style={{ paddingHorizontal: '8px' }}>
        <View style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
          <View style={{ width: '55%' }}>
            <Text style={PORTFOLIO_STYLES.eyebrowHeader}>Activity</Text>
          </View>
          <View style={{ width: '20%' }}>
            <Text style={PORTFOLIO_STYLES.eyebrowHeader}>Date</Text>
          </View>
          <View style={{ width: '25%' }}>
            <Text style={PORTFOLIO_STYLES.eyebrowHeader}>Duration</Text>
          </View>
        </View>
        {activities.map(({ id, date, description, duration_seconds }) => (
          <View
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
              paddingVertical: '6px',
              borderBottom: `1px solid ${COLORS.gray[200]}`,
              alignItems: 'center',
            }}
            key={id}
          >
            <View style={{ width: '55%', paddingRight: '12px' }}>
              <Text style={{ fontFamily: 'proximanova', fontSize: '9px', lineHeight: 1.3 }}>
                {description}
              </Text>
            </View>
            <View style={{ width: '20%', paddingRight: '12px' }}>
              <Text style={{ fontFamily: 'proximanova', fontSize: '9px', lineHeight: 1.3 }}>
                {DateTime.fromJSDate(date).toLocaleString(DateTime.DATE_SHORT)}
              </Text>
            </View>
            <View style={{ width: '25%' }}>
              <Text style={{ fontFamily: 'proximanova', fontSize: '9px', lineHeight: 1.3 }}>
                {millisecondsToHumanReadableString(duration_seconds * 1000, { maxUnit: 'hour' })}
              </Text>
            </View>
          </View>
        ))}
        <View
          style={{
            backgroundColor: COLORS.blue[50],
            borderRadius: '8px',
            textAlign: 'center',
            marginTop: '8px',
          }}
        >
          <Text
            style={{
              fontFamily: 'greycliffcf',
              fontSize: '10px',
              lineHeight: 1.3,
              marginVertical: '8px',
            }}
          >
            Total Time: {totalTime}
          </Text>
        </View>
      </View>
    </View>
  )
}
